export const CONSENT_CATEGORIES = [
  'essential',
  'analytical',
  'marketing',
  'personalization',
] as const;

export type ConsentCategory = (typeof CONSENT_CATEGORIES)[number];

export const NON_ESSENTIAL_CATEGORIES = [
  'analytical',
  'marketing',
  'personalization',
] as const satisfies readonly ConsentCategory[];

export type NonEssentialCategory = (typeof NON_ESSENTIAL_CATEGORIES)[number];

export const TC_CATEGORY_ID = {
  essential: '18',
  analytical: '15',
  marketing: '16',
  personalization: '17',
} as const satisfies Record<ConsentCategory, string>;

export type ConsentCategoryId =
  (typeof TC_CATEGORY_ID)[keyof typeof TC_CATEGORY_ID];

export const CATEGORY_BY_TC_ID: Record<string, ConsentCategory> =
  Object.entries(TC_CATEGORY_ID).reduce<Record<string, ConsentCategory>>(
    (categories, [category, id]) => {
      categories[id] = category as ConsentCategory;

      return categories;
    },
    {},
  );

export type ConsentDecision = Record<ConsentCategory, boolean>;

export const ALL_DENIED: ConsentDecision = {
  essential: true,
  analytical: false,
  marketing: false,
  personalization: false,
};

export const ALL_GRANTED: ConsentDecision = {
  essential: true,
  analytical: true,
  marketing: true,
  personalization: true,
};

export const createDecision = (
  overrides: Partial<ConsentDecision> = {},
): ConsentDecision => ({
  ...ALL_DENIED,
  ...overrides,
  essential: true,
});
